import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { DateTime } from "luxon";
import { memo } from "react";
import { TbClock } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { PassengersGroupTableRow } from "@/types/tasks.types";

const MemoizedCell = memo(({ value }: { value: DateTime }) => {
    return <div className="flex items-center h-full font-medium pl-7">{value?.toFormat("HH:mm")}</div>;
});
function FlightTimeColumn({ t }: { t: TFunction }): GridColDef<PassengersGroupTableRow> {
    return {
        field: "flightTime",
        headerName: t("flight-time"),
        minWidth: 130,
        renderHeader: (params) => <TableHeader Component={TbClock} title={params.colDef.headerName!} />,
        valueGetter: (_val, row) => row.flightTime,
        renderCell: ({ value }: GridRenderCellParams<PassengersGroupTableRow>) => <MemoizedCell value={value} />,
    };
}

export default FlightTimeColumn;
